"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TitleName = _interopRequireDefault(require("../../templates/TitleName.html"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TitleName =
/*#__PURE__*/
function (_Backbone$View) {
  _inherits(TitleName, _Backbone$View);

  function TitleName() {
    var _this;

    _classCallCheck(this, TitleName);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TitleName).apply(this, arguments));
    _this.template = _TitleName["default"];

    _this.render();

    return _this;
  }

  _createClass(TitleName, [{
    key: "_assembleLabel",
    value: function _assembleLabel() {
      var labelParts = [];
      labelParts.push(this.model.get('title'));

      if (!!this.model.get('firstCreatorName')) {
        labelParts.push(window.html('byLine', {
          creator: this.model.isMagazine ? this.model.get('publisher').name : this.model.get('firstCreatorName')
        }));
      }

      labelParts.push(this.model.availabilityText());
      labelParts.push(this.model.get('type').name);
      return labelParts.join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      var viewData = {
        titleId: this.model.id,
        href: this.model.titleDetailsUrl,
        ariaLabel: _.escape(this._assembleLabel()),
        title: this.model.get('title')
      };
      this.setElement($(this.template(viewData)));
    }
  }]);

  return TitleName;
}(Backbone.View);

exports["default"] = TitleName;